import { action, observable, toJS, makeObservable } from 'mobx';
// HELPERS
import { filterIaneoCourses, returnLastSixCourses } from '../pages/CoursesPage/helper/coursesStory';

import axios from 'axios';
import { errorAlert } from '../utils/alerts';

const { REACT_APP_API_URL } = process.env;

class CoursesStore {
  constructor(profileStore) {
    makeObservable(this, {
      currentTrainingData: observable,
      upcomingTrainingData: observable,
      offerTrainingData: observable,
      historyTrainingData: observable,
      getAllCourses: action
    });

    this.profileStore = profileStore;
  }

  currentTrainingData = [];

  upcomingTrainingData = [];

  offerTrainingData = [];

  historyTrainingData = [];

  async getAllCourses(t) {
    try {
      const authToken = await this.profileStore.getAuthToken();
      const { data } = await axios.get(`${REACT_APP_API_URL}/users/my/courses`, {
        headers: { Authorization: `Bearer ${authToken}` },
      });

      const { upcomingMyFeller, onGoing, offer, finish } = data;

      this.upcomingTrainingData = filterIaneoCourses(upcomingMyFeller);

      this.currentTrainingData = onGoing.map(course => ({
        title: course.name,
        progress: course['relative_progress'],
        duration: course.duration,
        remaining: course['remaining_duration'],
        link: course.link,
        id: course.id,
      }));

      this.offerTrainingData = filterIaneoCourses(offer);
      this.offerTrainingData = returnLastSixCourses(toJS(this.offerTrainingData));
      this.historyTrainingData = filterIaneoCourses(finish);
    } catch (e) {
      errorAlert(t('uploadAvatar.errorMessage'));
    }
  }
}

export default CoursesStore;
